import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as User from '../../utils/userHelpers';
import * as Utils from '../../utils/utils';
import * as Cart from '../../utils/cartHelper';
import * as TokenHelpers from '../../utils/tokenHelpers';
import * as UserActions from '../../actions/userActions';
import HeaderTop from '../../components/commons/header/HeaderTop';
import HeaderMiddle from '../../components/commons/header/HeaderMiddle';
import * as FBinit from '../../utils/fbintit';

class Header extends Component {

  constructor(props) {
    super(props);

    this.state = {
      settingsMenuVisibility: false,
      productsCount: 0,
    }
    this.onSettingsMenuClick = this.onSettingsMenuClick.bind(this);
    this.updateCart = this.updateCart.bind(this);
  }

  componentDidMount() {
    if (User.isLoggedIn()) {
      this.props.dispatch(UserActions.getProfileDetails());

      let cartProductsCount = Cart.getProductsCount();
      this.setState({ productsCount: cartProductsCount });
    }
    window.addEventListener('cart_changed', this.updateCart)
  }

  componentWillUnmount() {
    window.removeEventListener('cart_changed', this.updateCart);
  }

  render() {
    const { settingsMenuVisibility, productsCount } = this.state;
    const user = Utils.toJS(this.props.user);
    return (
      <div className={`header`}>
        <HeaderTop />
        <HeaderMiddle
          loggedUser={user}
          productsCount={productsCount}
          onSettingsMenuClick={this.onSettingsMenuClick}
          settingsMenuVisibility={settingsMenuVisibility}
          toggleSettingsMenu={() => this.setState({
            settingsMenuVisibility: !settingsMenuVisibility
          })}
        />
      </div>
    )
  }

  onSettingsMenuClick(action) {

    switch (action) {
      case 'profile':
        break;
      case 'logout':
        this.props.dispatch(UserActions.resetUserData());
        TokenHelpers.destroy();
        Cart.clearCart();

        FBinit.FBlogout();
        break;
    }
    this.setState({ settingsMenuVisibility: false })
  }

  updateCart() {
    let cartProductsCount = Cart.getProductsCount();
    console.log("CART_PRODUCTS_COUNT", cartProductsCount);
    this.setState({ productsCount: cartProductsCount });
  }

}

export default connect((state) => {
  return {
    user: state.getIn(['users', 'user']),
  };
})(Header);



// WEBPACK FOOTER //
// ./src/containers/commons/Header.js